import Parse from '../../utils/parse';
import { getStore } from '../../../app/store';
import { newError, cleanError } from '../errors';
import * as actionTypes from '../../constants/actions';
import * as analyticsTypes from '../../constants/analytics';
import { createCookie, getCookie, deleteCookie } from '../../utils/cookie';
import { setCurrentUser } from '../../utils/currentUser';
import {
  analyticsChangeUser,
  analyticsChangeClassRoom,
  analyticsTrackEvent,
} from '../../utils/analytics';

// Helpers
const setLoggedCookie = () => {
  const state = getStore().getState();

  createCookie(
    'aula-logged',
    state.institution.general.institution,
    365,
    '',
    '.aula.education'
  );
};

const parseLogin = (email, password) =>
  new Promise((resolve, reject) => {
    Parse.User.logIn(email, password).then(
      (user) => resolve(user),
      (error) => reject(error)
    );
  });

export const fetchLocalUser = () => (dispatch) => {
  if (Parse.User.current()) {
    dispatch({
      type: actionTypes.USER_FETCH_LOCAL,
      status: 'success',
      user: Parse.User.current(),
    });
  } else {
    dispatch({
      type: actionTypes.USER_FETCH_LOCAL,
    });
  }
};

export const fetchCurrentUser = (state) =>
  new Promise((resolve, reject) => {
    if (!state.user.user) {
      return resolve(null);
    }

    return Parse.Object.fromJSON({ ...state.user.user, className: '_User' })
      .fetch()
      .then(
        (user) => resolve(user),
        (error) => reject(error)
      );
  });

// Actions
export const fetchedUser = (user) => ({
  type: actionTypes.USER_FETCH_CURRENT,
  user,
});

const loginStart = () => ({
  type: actionTypes.USER_LOGIN,
  status: 'started',
});

const loginSuccess = (user, dispatch) => {
  dispatch({
    type: actionTypes.USER_LOGIN,
    status: 'success',
    user,
  });
};

const loginError = (error, dispatch) => {
  dispatch(newError(error, 'login'));
  dispatch({
    type: actionTypes.USER_LOGIN,
    status: 'error',
    error,
  });
};

export const login = (email, password) => (dispatch, getState) => {
  if (!email || !password) {
    const err = { message: 'Missing email or password' };
    return loginError(err, dispatch);
  }
  // Starting the login process
  dispatch(loginStart());
  dispatch(cleanError());

  // Login with Parse
  return parseLogin(email.toLowerCase(), password).then(
    // Dispatch successfull login
    (user) => {
      setLoggedCookie();
      loginSuccess(user, dispatch);
      analyticsTrackEvent(analyticsTypes.INTENTIONAL_LOGIN, {}, user.toJSON());
      analyticsChangeUser(getState);
      analyticsChangeClassRoom(getState);
      return { code: 202 };
    },
    (error) => loginError(error, dispatch)
  );
};

export const logout = () => (dispatch, getState) =>
  new Promise((resolve) => {
    if (!getState().user.isLogged) {
      const err = 'User not logged in'; // new Error('User not logged in');
      resolve(err);
      // logoutError(err, dispatch);
      return;
    }

    dispatch({
      type: actionTypes.USER_LOGOUT,
      status: 'started',
    });

    deleteCookie('aula-logged', '', '.aula.education');
    Parse.User.logOut().then(
      () => {
        dispatch({
          type: actionTypes.USER_LOGOUT,
          status: 'success',
        });
        analyticsChangeUser(getState);
        analyticsChangeClassRoom(getState);

        resolve();
      },
      (err) => resolve(err)
    );
  });

export const fetchCurrentUserIfNeeded = () => (dispatch, getState) =>
  fetchCurrentUser(getState()).then(
    (user) => user && dispatch(fetchedUser(user)),
    (error) => dispatch(newError(error, 'fetchCurrentUser'))
  );

export const getSessionToken = (store) => () => {
  if (store.getState().user.isLogged) {
    // push('/feed');
  } else {
    // push('/');
  }
};

export const loginWithTokenAction = (token) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch(loginStart());
    Parse.User.become(token).then(
      (user) => {
        setCurrentUser({
          ...user.toJSON(),
          id: user.id,
        });
        loginSuccess(user, dispatch);
        resolve(user);
      },
      (error) => {
        loginError(error, dispatch);
        reject();
      }
    );
  });

export const loginWithToken = (token) => {
  const store = getStore();
  const { user } = store.getState();
  if (!user.isLogged && !user.isLoggingIn && !user.isRegistering) {
    return store.dispatch(loginWithTokenAction(token));
  }

  return Promise.resolve(null);
};

export const loginIfCookie = () => {
  const store = getStore();
  const { user, institution } = store.getState();
  const token = getCookie('sso-session-t');
  if (token && !user.isLoggingIn && !user.isRegistering) {
    deleteCookie('sso-session-t', '', `.${institution.general.base_domain}`);
    return store.dispatch(loginWithTokenAction(token));
  }

  return Promise.resolve(null);
};
